import { render, staticRenderFns } from "./CardDescriptionTable.vue?vue&type=template&id=039d0360&"
import script from "./CardDescriptionTable.vue?vue&type=script&lang=js&"
export * from "./CardDescriptionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports